import(/* webpackMode: "eager" */ "/app/apps/frodo/src/app/search/[[...facets]]/error.tsx");
